import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./assets/tailwind/index.css";
import { setUserProps, trackException } from "./helpers";
import { getLanguageFromUrl } from "./helpers/languageUtils";
import { HomeView } from "./features/routes";

setUserProps({ locale: getLanguageFromUrl(window.location.pathname) });

window.addEventListener("error", (event) => {
  trackException(event.message, {
    fatal: true,
    source: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  trackException(reason?.message || reason, {
    fatal: true,
    kind: "unhandled_rejection",
  });
});

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  // Pre-rendered by react-snap (home pages). Preload the lazy home chunk
  // before hydrating, otherwise hydration would briefly replace the static
  // HTML with the Suspense fallback.
  const hydrate = () => ReactDOM.hydrate(<App />, rootElement);
  HomeView.preload().then(hydrate, hydrate);
} else {
  ReactDOM.render(<App />, rootElement);
}
